import clsx from "clsx";
import styles from "./styles.module.css";

function InitialOrderLoader() {
  return (
    <div className={clsx(styles.loaderContainer, styles.initialCheckorderLoaderContainer)}>
      <div className={clsx(styles.loader)}>&nbsp;</div>
      <div className={clsx(styles.loaderbelowtext)}>Please wait while order is being created ... Don't reload or leave the page.</div>
    </div>
  )
}
export default InitialOrderLoader;